import { SalesPipelineQuoteRequestStatusGql, SalesPipelineStatusGql } from "@/graphql/codegen/graphql"

export const OPPORTUNITY_PIPELINE_TAB = "opportunity-pipeline"
export const SALES_SEARCH_LIMIT = 20
export const SUGGESTION_DEBOUNCE_MS = 300

export const SALES_OPPORTUNITY_STATUS_TO_LABEL: Record<SalesPipelineStatusGql, string> = {
  [SalesPipelineStatusGql.Open]: "Open",
  [SalesPipelineStatusGql.Won]: "Won",
  [SalesPipelineStatusGql.Lost]: "Lost",
  [SalesPipelineStatusGql.OpenDenied]: "Open - Denied",
  [SalesPipelineStatusGql.Dead]: "Dead",
} as const

export const SALES_OPPORTUNITY_STATUS_TO_CLASS_NAME: Record<SalesPipelineStatusGql, string> = {
  [SalesPipelineStatusGql.Open]: "bg-primary-200 text-gray-900",
  [SalesPipelineStatusGql.Won]: "bg-tertiary-green-100 text-gray-900",
  [SalesPipelineStatusGql.Lost]: "bg-tertiary-orange-300 text-gray-900",
  [SalesPipelineStatusGql.OpenDenied]: "bg-tertiary-purple-300 text-gray-900",
  [SalesPipelineStatusGql.Dead]: "bg-secondary-200 text-gray-900",
} as const

export const SALES_OPPORTUNITY_QUOTE_STATUS_TO_LABEL: Record<SalesPipelineQuoteRequestStatusGql, string> = {
  [SalesPipelineQuoteRequestStatusGql.Draft]: "Draft",
  [SalesPipelineQuoteRequestStatusGql.Submitted]: "Submitted",
  [SalesPipelineQuoteRequestStatusGql.Approved]: "Approved",
  [SalesPipelineQuoteRequestStatusGql.Denied]: "Denied",
  [SalesPipelineQuoteRequestStatusGql.Expired]: "Expired",
  [SalesPipelineQuoteRequestStatusGql.Cancelled]: "Cancelled",
} as const

export const SALES_OPPORTUNITY_QUOTE_STATUS_TO_CLASS_NAME: Record<SalesPipelineQuoteRequestStatusGql, string> = {
  [SalesPipelineQuoteRequestStatusGql.Draft]: "bg-tertiary-yellow-300 text-gray-900",
  [SalesPipelineQuoteRequestStatusGql.Submitted]: "bg-primary-200 text-gray-900",
  [SalesPipelineQuoteRequestStatusGql.Approved]: "bg-tertiary-green-100 text-gray-900",
  [SalesPipelineQuoteRequestStatusGql.Denied]: "bg-secondary-200 text-gray-900",
  [SalesPipelineQuoteRequestStatusGql.Expired]: "bg-secondary-200 text-gray-900",
  [SalesPipelineQuoteRequestStatusGql.Cancelled]: "bg-secondary-200 text-gray-900",
} as const
